import { EditorService, EditorServiceModels } from '@editor/client-rest-api';
import { LicenseType } from '../utils/getUserLicenseType';
import { setDefaultOptionWithId } from '../actions/setDefaultOptionWithId';
import { setCategoryNameWithId } from '../actions/setCategoryNameWithId';
import { clearDefaultOptions } from '../actions/clearDefaultOptions';
import { logUsage } from 'owa-analytics';
import { isDogfoodEnv } from 'owa-metatags';

function getEditorServiceEndPoint(): string {
    return isDogfoodEnv()
        ? 'https://nleditor.osi.officeppe.net'
        : 'https://nleditor.osi.office.net';
}

async function doFetch(languageId: string): Promise<EditorServiceModels.CritiqueCategoryInfo[]> {
    const client = new EditorService({ baseUri: getEditorServiceEndPoint() });
    const response = await client.configV2({
        appId: 'Outlook_Online',
        languageId: languageId,
        descriptors: [
            {
                name: 'LicenseType',
                value: LicenseType.Subscription as string,
            },
        ],
    });

    if (response?.responseStatus === EditorServiceModels.ResponseStatus.Success) {
        return response.critiqueCategoryInfoList;
    } else {
        logUsage('EditorProofingCallFailed', { locale: languageId });
        return Promise.resolve([]);
    }
}

export default async function fetchDefaultConfigFromService(languageId: string): Promise<void> {
    const response = await doFetch(languageId);
    clearDefaultOptions();
    response?.forEach(critiqueCategoryInfo => {
        const categoryName = critiqueCategoryInfo.name;
        const categoryId = critiqueCategoryInfo.id;
        const critiqueTypeInfoList = critiqueCategoryInfo.critiqueTypeInfoList;

        setCategoryNameWithId(categoryId, categoryName);
        critiqueTypeInfoList?.forEach(critiqueTypeInfo => {
            setDefaultOptionWithId(critiqueTypeInfo.id, categoryId, critiqueTypeInfo);
        });
    });
}
